export default "__VITE_ASSET__a88b282e__"